import { AiAssist } from "@aircall/react-icons";
import { useTranslation } from "react-i18next";

import { useSummaryRule } from "@/hooks/useSummaryRule/useSummaryRule";
import { NoDataBanner } from "../NoDataBanner/NoDataBanner";

import { ContentProps } from "./SectionSummary.decl";

import { useCall } from "@/hooks/useCall/useCall";

function Content({ call }: ContentProps) {
  const { t } = useTranslation();

  if (!call?.summary) {
    return (
      <NoDataBanner
        text={t("call_context.no_summary_generated_text")}
        data-test="no-summary-generated"
      />
    );
  }

  return (
    <p className="text-base font-normal" data-test="call-context-summary-text">
      {call.summary}
    </p>
  );
}

export function SummarySection() {
  const { t } = useTranslation();

  const { call } = useCall();
  const { shouldDisplaySummary } = useSummaryRule();

  if (!shouldDisplaySummary) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <p className="text-xl font-medium">{t("call_context.summary_title")}</p>
        <AiAssist className="size-4" />
      </div>
      <Content call={call} />
    </div>
  );
}
